export type CanShowProofOfPickupParams = Readonly<{
  userType: string | undefined;
  shipmentStatus: string | undefined;
  isPoPSubmitted: boolean | undefined;
  isOffPlatform: boolean;
}>;

export function canShowProofOfPickup({
  userType,
  shipmentStatus,
  isPoPSubmitted,
  isOffPlatform,
}: CanShowProofOfPickupParams): boolean {
  if (userType !== "provider") return false;
  if (isOffPlatform) return false;
  if (isPoPSubmitted) return false;
  return shipmentStatus === "Booked";
}
